





















































































































































































































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { AxiosVue } from '@/AxiosVue';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import modalCrearOC from '@/pantallas/Conecta/OrdenesCompra/modalCrearOC.vue';
import modalCargarArchivo from '@/pantallas/Conecta/OrdenesCompra/modalCargarArchivo.vue';
import ModalExportarCRM from '@/pantallas/Conecta/OrdenesCompra/exportar_a_crm.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import modalAutorizadores from './modalAutorizadores.vue';
import ModalVerEstadoSeries from './ModalVerEstadoSeries.vue';
import ModalVerCostos from './ModalVerCostos.vue';

import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { utils, writeFileXLSX } from 'xlsx';
import moment from 'moment';
import VerDetalleRutaModal from './VerDetalleModal.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    modalCrearOC,
    modalCargarArchivo,
    ModalExportarCRM,
    DatePicker,
    VerDetalleRutaModal,
    modalAutorizadores,
    ModalVerEstadoSeries,
    ModalVerCostos,
  },
})
export default class GrillaOrdenesCompra extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.OrdenesCompra;

  @Prop({ default: null }) filtro_proveedor: any;
  @Prop({ default: null }) filtro_rut_contable: any;
  @Prop({ default: null }) filtro_equipo: any;
  filtro_inicio_fecha_alta: any = moment().subtract(1, 'months');
  filtro_fin_fecha_alta: any = moment();
  filtro_estado: any = '';

  showAutorizadores: boolean = false;
  gridApi: GridApi = null;
  ModalState: boolean = false;
  CargaArchivoModalState: boolean = false;
  ExportarCRMModalState: boolean = false;
  oc_seleccionada: Number = null;
  //po_seleccionada: any = null;
  ordesList: any = [];
  mostrarModal: boolean = false;
  filter_data: any = [];
  loadingService = new LoadingService();
  showReporteGenerado: boolean = false;
  texto_reporte: string = 'TEXTO CUERPO MODAL';
  mostrarModalVerDetalle: boolean = false;
  autorizadoresModal: any;
  dolarCompra: Number = null;
  mounted() {
    this.autorizadoresModal = this.$refs.modalAutorizadores;
  }
  closeModal() {
    this.showAutorizadores = false;
    this.loadingService.hideLoading();
  }

  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };

  AccionCargarArchivo: PermisoAccion = {
    accionCodigo: 93,
    visible: false,
  };

  AccionVerDetalle: PermisoAccion = {
    accionCodigo: 47,
    visible: false,
  };

  accionEnviar: PermisoAccion = {
    accionCodigo: 90,
    visible: false,
  };

  accionExportaraCRM: PermisoAccion = {
    accionCodigo: 106,
    visible: false,
  };
  accionSolicitarAutorizacion: PermisoAccion = {
    accionCodigo: 110,
    visible: false,
  };
  accionVerAutorizacion: PermisoAccion = {
    accionCodigo: 111,
    visible: false,
  };
  accionIncluirCostosImportacion: PermisoAccion = {
    accionCodigo: 127,
    visible: false,
  };
  /*
  accionEliminar: PermisoAccion = {
    accionCodigo: 5,
    visible: false,
  };
  */

  /*
  formsFields: {
    fechaDesde: { id: string; label: string; value: any };
    fechaHasta: { id: string; label: string; value: any };
    } = {
    fechaDesde: {
      id: '1110',
      label: 'Desde',
      value: moment(new Date()).add(-7, 'days'),
    },
    fechaHasta: {
      id: '1111',
      label: 'Hasta',
      value: moment(new Date()),
    },
  };
  */
  accionesTotales: PermisoAccion[] = [
    this.AccionCargarArchivo,
    this.accionEditar,
    this.AccionVerDetalle,
    this.accionEnviar,
    this.accionExportaraCRM,
    this.accionSolicitarAutorizacion,
    this.accionVerAutorizacion,
    this.accionIncluirCostosImportacion,
  ];

  constructor() {
    super();
    actionsEvent.onEditar(this.handlerbuttonmodalEDIT);
    actionsEvent.onCargarArchivo(this.callbackCargarArchivo);
    actionsEvent.onCompartir(this.callbackExportar);
    actionsEvent.onEnviar(this.callbackcompartir);
    actionsEvent.onExportaraCRM(this.callbackExportarCRM);
    actionsEvent.onSoliciarAutorizacion(this.solicitarAuto);
    actionsEvent.onVerAutorizacion(this.verAuto);
    actionsEvent.onEditarAutorizadores(this.editarAutorizadores);
    actionsEvent.onVerEstadoSeries(this.verEstadoSeries);
    actionsEvent.onIncluirCostosImportacion(this.incluirCostos);
  }
  edicionAutorizadores: boolean = false;
  async editarAutorizadores(params: ICellRendererParams) {
    if (params.data['Estado'] == 'ANULADO') {
      this.$snotify.error('La Orden De Compra Se Encuentra Anulada', 3000);
      return;
    }
    if (params.data['Cantidad Ingresada'] > 0) {
      this.$snotify.error('Autorización ya se encuentra Aprobada.', 3000);
      return;
    }

    if (params.data['Estado de Autorización'] == 'Aprobado') {
      this.$snotify.error('Autorización ya se encuentra Aprobada.', 3000);
      return;
    }

    if (params.data['Estado de Autorización'] == 'Sin Solicitar') {
      this.$snotify.error('Autorización No Se Encuentra Solicitada', 3000);
      return;
    }
    if (params.data['Estado de Autorización'] == 'Rechazado') {
      this.$snotify.error('Autorización Se Encuentra Rechazada', 3000);
      return;
    }

    /* this.auto_reporte = await this.exportar_autorizacion(
      params.data['Compra Número']
    ); */
    this.rowSelected = {
      compranumero: params.data['Compra Número'],
      autoobs: params.data['Descripción'],
    };
    this.edicionAutorizadores = true;
    this.compranumero = params.data['Compra Número'];
    this.autorizadoresModal.loadSelected(this.compranumero);
    this.showAutorizadores = true;
  }
  modalEstadoSeries: boolean = false;
  verEstadoSeries(params: ICellRendererParams) {
    if (
      params.data['Estado'] != 'EN STOCK' &&
      params.data['Estado'] != 'STOCK PARCIAL'
    ) {
      this.$snotify.error('No se han cargado series', 3000);
      return;
    }
    this.compranumero = params.data['Compra Número'];
    this.modalEstadoSeries = true;
  }
  ModalVerCostos: boolean = false;
  tipoProveedor: boolean = false;
  incluirCostos(params: ICellRendererParams) {
    if (params.data['Tipo Proveedor'] != 'INTERNACIONAL') {
      this.$snotify.error(
        `Los costos de importación se agregan solo si es un proveedor internacional.`,
        3000
      );
      return;
    }

    if (
      params.data['Estado'] != 'RECIBIDO' &&
      params.data['Estado'] != 'STOCK PARCIAL' &&
      params.data['Estado'] != 'EN STOCK'
    ) {
      this.$snotify.error(
        `La orden de compra se encuentra en estado ${params.data['Estado']}, no se puede ver costos.`,
        3000
      );
      return;
    }
    if (params.data['Estado de Autorización'] != 'Aprobado') {
      this.$snotify.error(
        `La autorización esta en estado ${params.data['Estado de Autorización']}, no se puede ver costos.`,
        3000
      );
      return;
    }

    this.compranumero = params.data['Compra Número'];
    this.ModalVerCostos = true;
  }

  async generaReporteFactor() {
    let body: { [key: string]: string } = {
      filtro_proveedor: this.filtro_proveedor || '',
      filtro_rut_contable: this.filtro_rut_contable || '',
      filtro_equipo: this.filtro_equipo || '',
      filtro_inicio_fecha_alta: this.filtro_inicio_fecha_alta,
      filtro_fin_fecha_alta: this.filtro_fin_fecha_alta,
      filtro_estado: this.filtro_estado || '',
      extension: 'csv',
    };

    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchOrdenesCompra(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/exportar_costos'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar');
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async editAutorizadores(selecteds: any) {
    let self = this;
    let autoid_reporte = await this.exportar_autorizacion(
      this.rowSelected.compranumero
    );
    return fetchOrdenesCompra(
      {
        totalNames: selecteds.names,
        removed: selecteds.removed,
        new: selecteds.new,
        usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,
        autoobs: this.rowSelected.autoobs,
        autoid_reporte: autoid_reporte,
        compranumero: this.rowSelected.compranumero,
        id_cliente: JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .clienteDefecto,
      },
      'conectaOrdenesCompra/edit_autorizadores'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.showLoading();
          self.applyfilters();
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return null;
        }
      })
      .catch((error: any) => {
        self.$snotify.error(error, { timeout: 3000 });
        return null;
      })
      .finally(() => {
        self.loadingService.hideLoading();
        this.showAutorizadores = false;
        return null;
      });
  }

  auto_reporte: any;
  rowSelected: any;
  async solicitarAuto(params: ICellRendererParams) {
    if (params.data['Estado'] == 'ANULADO') {
      this.$snotify.error('La Orden De Compra Se Encuentra Anulada', 3000);

      this.loadingService.hideLoading();
      return null;
    }
    if (params.data['Cantidad Ingresada'] > 0) {
      this.$snotify.error('Autorización ya se encuentra Aprobada', 3000);

      this.loadingService.hideLoading();
      return null;
    }
    if (params.data['Estado de Autorización'] == 'Pendiente') {
      this.$snotify.error('Autorización ya se Encuentra Solicitada', 3000);
      this.loadingService.hideLoading();
      return null;
    }
    if (params.data['Estado de Autorización'] == 'Aprobado') {
      this.$snotify.error('Autorización ya se encuentra Aprobada', 3000);
      this.loadingService.hideLoading();
      return null;
    }

    /* this.auto_reporte = await this.exportar_autorizacion(
      params.data['Compra Número']
    ); */
    this.rowSelected = {
      compranumero: params.data['Compra Número'],
      autoobs: params.data['Descripción'],
      //autoid_reporte: this.auto_reporte,
    };
    this.edicionAutorizadores = false;
    this.showAutorizadores = true;
    this.autorizadoresModal.reloadData();
    return true;
  }

  async requestAutorization(selecteds: any) {
    let self = this;
    let autoid_reporte = await this.exportar_autorizacion(
      this.rowSelected.compranumero
    );
    return fetchOrdenesCompra(
      {
        autorizadores: selecteds,
        usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,
        autoobs: this.rowSelected.autoobs,
        autoid_reporte: autoid_reporte,
        compranumero: this.rowSelected.compranumero,
        edicion: this.edicionAutorizadores,
        id_cliente: JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .clienteDefecto,
      },
      'conectaOrdenesCompra/autorizar'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.showLoading();
          self.applyfilters();
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return null;
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ocurrió un error al solicitar autorización, por favor reintente',
          { timeout: 3000 }
        );
        return null;
      })
      .finally(() => {
        self.loadingService.hideLoading();
        this.showAutorizadores = false;
        return null;
      });
  }

  compranumero: any = '';
  async verAuto(params: ICellRendererParams): Promise<any> {
    if (params.data['Estado de Autorización'] == 'Sin Solicitar') {
      this.$snotify.error('No cuenta con autorizaciones', 3000);
      return null;
    }
    this.compranumero = params.data['Compra Número'];
    this.mostrarModalVerDetalle = true;
  }

  handleCierreModalVerDetalle(): Promise<any> {
    this.mostrarModalVerDetalle = false;
    this.ModalVerCostos = false;
    this.applyfilters();
    return null;
  }

  async callbackExportarCRM(params: ICellRendererParams) {
    if (params.data['Estado de Autorización'] != 'Aprobado') {
      this.$snotify.error(
        'La solicitud está sin Aprobar y no se puede cargar Archivo.'
      );
      return;
    }

    if (params.data['Estado'] == 'ANULADO') {
      this.$snotify.error(
        'La solicitud está Anulada y no se puede cargar Archivo.'
      );
      return;
    }

    if (params.data['Estado'] != 'EN STOCK') {
      this.$snotify.error(
        `La solicitud está en estado ${params.data['Estado']} y no se puede cargar Archivo.`
      );
      return;
    }

    this.oc_seleccionada = params.data['Compra Número'];
    //this.ExportarCRMModalState = true;
    return fetchOrdenesCompra(
      {
        id_orden_compra: this.oc_seleccionada,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/get_tipoeqname_from_oc'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_tipoeqname_from_oc');
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          let headers = {
            //header: ['Equipo y Periferico','Suma de comprobación de fila','Fecha de modificación','Nombre','Identificador','Razón para el estado','Propiedad Equipo','Propietario','Producto','Serie','Plataforma','Cambio de Batería','Simcard','Fecha Cambio de Batería','Observaciones'],
          };
          const ws = utils.json_to_sheet(data.data.LISTA, headers);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, 'Plantilla');
          writeFileXLSX(wb, 'ExportarCRM.xlsx');
          this.$snotify.success('Plantilla Excel descargada con éxito');
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  callbackcompartir(params: ICellRendererParams) {
    const OC = params.data['Compra Número'];
    if (params.data['Estado de Autorización'] != 'Aprobado') {
      this.$snotify.error(
        'La solicitud está sin Aprobar y no se puede ver el PDF.'
      );
      return;
    }
    const exp_pdf = this.exportar_fila_pdf(OC);
  }

  callbackExportar(params: ICellRendererParams) {
    if (params.data['Estado de Autorización'] != 'Aprobado') {
      this.$snotify.error(
        'La solicitud está sin Aprobar y no se puede cargar Archivo.'
      );
      return;
    }

    if (params.data['Estado'] == 'RECIBIDO') {
      this.$snotify.error(
        'La solicitud está en estado Recibido y no se puede cargar Archivo.'
      );
      return;
    }

    const xl = this.get_export_inet(params.data['Compra Número']);
  }
  tieneCostos: boolean = false;
  oc_flete: string;
  cantidad_esperada: number;
  valorflete: number;
  callbackCargarArchivo(params: ICellRendererParams) {
    if (params.data['Estado de Autorización'] == 'Rechazado') {
      this.$snotify.error(
        'La solicitud está Rechazada y no se puede cargar Archivo.'
      );
      return;
    }

    if (params.data['Estado de Autorización'] != 'Aprobado') {
      this.$snotify.error(
        'La solicitud está sin Aprobar y no se puede cargar Archivo.'
      );
      return;
    }

    if (
      params.data['Estado'] != 'RECIBIDO' &&
      params.data['Estado'] != 'STOCK PARCIAL'
    ) {
      this.$snotify.error(
        `La solicitud esta en estado ${params.data['Estado']} y no se puede cargar Archivo.`
      );
      return;
    }
    this.tieneCostos = params.data.compraregistra_importacion == 't';
    this.CargaArchivoModalState = true;
    this.cantidad_esperada = parseInt(params.data['Cantidad Solicitada']);
    this.oc_flete = params.data.compraflete;
    this.tipoProveedor = params.data['Tipo Proveedor'] == 'INTERNACIONAL';
    this.oc_seleccionada = params.data['Compra Número'];
    this.dolarCompra = params.data['Precio Dolar'];
    //this.po_seleccionada = params.data.comprapo;
  }

  modalCargarArchivoCallback(event: any) {
    this.CargaArchivoModalState = event;
  }

  modalexpCRMCallback(event: any) {
    this.ExportarCRMModalState = event;
  }

  modalOCCallback(event: any) {
    this.cleanfilters();

    this.ModalState = event;
  }

  handlerbuttonmodal() {
    this.oc_seleccionada = null;
    //this.po_seleccionada = null;
    this.ModalState = true;
    this.editable = null;
  }
  editable: any;
  editableEq: boolean = false;
  handlerbuttonmodalEDIT(params: ICellRendererParams) {
    if (params.data['Estado de Autorización'] == 'Pendiente') {
      this.$snotify.error(
        'La solicitud está en estado ' +
          params.data['Estado de Autorización'] +
          ' y no se puede editar.'
      );
      return;
    }
    this.ModalState = true;
    this.editable = params.data['Estado'];
    let estadoAuto = params.data['Estado de Autorización'];
    this.editableEq = estadoAuto != 'Aprobado';
    this.oc_seleccionada = params.data['Compra Número'];
    //this.po_seleccionada = params.data.comprapo;
  }

  formatMoney(params: any) {
    const numericValue = parseFloat(params.value);
    if (!isNaN(numericValue)) {
      return numericValue
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return params.value;
  }

  gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Compra Número',
        field: 'Compra Número',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Descripción',
        field: 'Descripción',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Solicitado Por',
        field: 'Solicitado Por',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Emisión',
        field: 'Fecha Emisión',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha Llegada',
        field: 'Fecha Llegada',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cuenta Costo',
        field: 'Cuenta Costo',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Rut Proveedor',
        field: 'Rut Proveedor',
        hide: false,
        resizable: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Razón Social Proveedor',
        field: 'Razón',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cantidad Solicitada',
        field: 'Cantidad Solicitada',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Monto Total',
        field: 'Monto Total',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Valor Costos de Importación',
        field: 'Valor Costos de Importación',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Cantidad Ingresada',
        field: 'Cantidad Ingresada',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'Estado',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Número Reporte',
        field: 'Número Reporte',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado de Autorización',
        field: 'Estado de Autorización',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado Carga INET',
        field: 'Estado Carga INET',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Movimiento INET',
        field: 'Movimiento INET',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Respuesta Carga INET',
        field: 'Respuesta Carga INET',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado Carga CRM',
        field: 'Estado Carga CRM',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Respuesta Carga CRM',
        field: 'Respuesta Carga CRM',
        resizable: true,
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo Proveedor',
        field: 'Tipo Proveedor',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Costos De Importación',
        field: 'Costos De Importación',
        hide: false,
        cellStyle: { textAlign: 'left' },
      },
    ].map(x => ({
      width: 300,
      hide: false,
      ...x,
    })),
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 50,
    onGridReady: this.handleGridReady,
  };

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getOrders();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');

    //data para los dropdown de los filtros
    this.filter_data = await this.get_filter_data();

    //precargo los filtros de fecha con un mes de rango
    //this.filtro_inicio_fecha_alta = moment(new Date()).subtract(1, 'months');
    //this.filtro_fin_fecha_alta = moment(new Date());
  }

  async getOrders() {
    this.loadingService.showLoading();
    return fetchOrdenesCompra(
      {
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          this.loadingService.hideLoading();
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading();
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async get_filter_data() {
    this.loadingService.showLoading(undefined, 'get_filter_data');
    return fetchOrdenesCompra(
      { '': '' },
      'conectaOrdenesCompra/get_grilla_filters'
    )
      .then((data: any) => {
        var elements = document.getElementsByClassName('v-list__tile__title');
        Array.from(elements).forEach(function(element) {
          if (element.innerHTML == 'Ver Detalle') {
            element.innerHTML = 'Exportar Excel Inet';
          }
        });

        this.loadingService.hideLoading('get_filter_data');
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async applyfilters() {
    this.loadingService.showLoading();
    return fetchOrdenesCompra(
      {
        filtro_proveedor: this.filtro_proveedor,
        filtro_rut_contable: this.filtro_rut_contable,
        filtro_equipo: this.filtro_equipo,
        filtro_inicio_fecha_alta: this.filtro_inicio_fecha_alta,
        filtro_fin_fecha_alta: this.filtro_fin_fecha_alta,
        filtro_estado: this.filtro_estado,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/get_filtered_oc'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.ordesList = data.data.data.LISTA;
          this.gridApi.setRowData(this.ordesList);
          this.loadingService.hideLoading('applyfilters');
          return null;
        } else {
          this.loadingService.hideLoading('applyfilters');
          this.ordesList = [];
          this.gridApi.setRowData(this.ordesList);
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        this.loadingService.hideLoading('applyfilters');
        return null;
      })
      .finally(() => {
        this.loadingService.hideLoading('applyfilters');
        return null;
      });
  }

  async cleanfilters() {
    this.filtro_proveedor = null;
    this.filtro_rut_contable = null;
    this.filtro_equipo = null;
    this.filtro_inicio_fecha_alta = moment().subtract(1, 'month');
    this.filtro_fin_fecha_alta = moment();
    this.filtro_estado = null;
    this.ordesList = await this.getOrders();
    this.gridApi.setRowData(this.ordesList);
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;

    return id;
  }

  async btn_exportar() {
    let body: { [key: string]: string } = {
      filtro_proveedor: this.filtro_proveedor || '',
      filtro_rut_contable: this.filtro_rut_contable || '',
      filtro_equipo: this.filtro_equipo || '',
      filtro_inicio_fecha_alta: this.filtro_inicio_fecha_alta,
      filtro_fin_fecha_alta: this.filtro_fin_fecha_alta,
      filtro_estado: this.filtro_estado || '',
      extension: 'csv',
      tipo_alerta: 'CONECTA_ORDENES_COMPRA',
    };

    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchOrdenesCompra(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/exportar'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('btn_exportar');
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_export_inet(oc: any) {
    let body: { [key: string]: string } = {
      extension: 'xlsx',
      tipo_alerta: 'CONECTA_ORDENES_COMPRA',
      id_orden_compra: oc,
    };

    this.loadingService.showLoading(undefined, 'conecta_exportOC_Inet');

    return fetchOrdenesCompra(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conecta_exportOC_Inet'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('conecta_exportOC_Inet');
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        return data.data.data.LISTA;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async exportar_autorizacion(oc: any) {
    this.loadingService.showLoading();
    let body: { [key: string]: string } = {
      extension: 'pdf',
      tipo_alerta: 'AUTORIZACION_ORDENES_COMPRA',
      orden_compra: oc,
    };
    return fetchOrdenesCompra(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        modulo_id: '147',
      },
      'conectaOrdenesCompra/exportar_autorizacion'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          return data.data.data;
        }
        this.loadingService.hideLoading();
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async exportar_fila_pdf(oc: any) {
    this.loadingService.showLoading(undefined, 'exportar_fila_pdf');
    let body: { [key: string]: string } = {
      extension: 'pdf',
      tipo_alerta: 'CONECTA_ORDENES_COMPRA',
      orden_compra: oc,
    };
    return fetchOrdenesCompra(
      {
        clienteDefecto: this.getCliente(),
        user_id: this.getUserID(),
        body: body,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/exportar_fila_pdf'
    )
      .then((data: any) => {
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        }
        this.loadingService.hideLoading('exportar_fila_pdf');
        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }
}
